module.exports = __webpack_public_path__ + "static/media/CoronaEN.c796ed61.pdf";